import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import FormAddPayment from './FormAddPayment';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTablePayments from './DataReactTablePayments';
import { formatNumber } from '../../Utils/Money';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ShowPayment from './ShowPayment';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import ChipShowRetentionToInvoice from './ChipShowRetentionToInvoice';

const PaymentSection = ({ selectedInvoiceFromProps }) => {
    const [isMounted, setIsMounted] = useState(false);
    const [invoices, setInvoices] = useState([]); // Listado de Facturas que se muestra en el Select
    const [selectedInvoice, setSelectedInvoice] = useState(null); //Factura Seleccionada por el usuario
    const [totalInvoice, setTotalInvoice] = useState(0); // Monto total de la factura
    const [load, setLoad] = useState(true);
    const [loadTable, setLoadTable] = useState(false);
    const [payments, setPayments] = useState([]); // Información que alimenta la tabla de todos los pagos
    const [paymentById, setPaymentById] = useState(null); // Pagos por factura seleccionada
    const [invoiceInfo, setInvoiceInfo] = useState(null); //Factura completa 
    const [incomeToPay, setIncomeToPay] = useState(0); // valor faltante a pagar por factura 
    const [onEdit, setOnEdit] = useState(false);
    const [paymentToEdit, setPaymentToEdit] = useState(null); //pago que se va a editar
    const [showPaymentPDF, setShowPaymentPDF] = useState(false); //Muestra el PDF de un pago en especifico
    const [retentionsToInvoice, setRetentionsToInvoice] = useState(null); // Retenciones creadas a la factura
    const [totalValueFromRetentionsToInvoice, setTotalValueFromRetentionsToInvoice] = useState(0) //Suma de todas las retenciones a la factura

    //const focusPayments = useRef(null);


    useEffect(() => {
        setIsMounted(true);
        if (selectedInvoiceFromProps !== null && selectedInvoiceFromProps !== undefined && selectedInvoiceFromProps.hasOwnProperty('selectedInvoice')) {
            setSelectedInvoice(selectedInvoiceFromProps.selectedInvoice);
        }

        listInvoice();
        getPayments();

        return () => {
            setIsMounted(false);
        }
    }, []);

    useEffect(() => {
        calculateValueToPay();
        if (payments.length > 0) {
            setLoadTable(false);
        }
    }, [payments, selectedInvoice, paymentById]);

   /*  useEffect(()=>{
        if(paymentById !== null){
            focusPayments.current.focus({preventScroll:false});
        }
    }, [paymentById]) */

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const calculateValueToPay = async () => {
        let incomeToPay = 0;
        if (selectedInvoice !== null && selectedInvoice !== undefined) {
            let invoicePayments = await getAllPaymentsById(selectedInvoice.id_factura_t);
            let separatePaymentFromRetentions = invoicePayments.filter((element) => element.retencion !== true)
            let sumPayments = addPayments(separatePaymentFromRetentions);
            let separateRetentionsFromPayments = invoicePayments.filter((element) => element.retencion !== false);
            setRetentionsToInvoice(separateRetentionsFromPayments);
            let sumRetentionsToInvoice = calculateRetentionsValueToInvoice(separateRetentionsFromPayments); //suma la cantidad de todas las retenciones
            setInvoiceInfo(selectedInvoice);
            let totales_factura = calculateTotal(selectedInvoice);
            //console.log('TOTALESFAC', totales_factura);
            let valot_total_fac = totales_factura?.total_tercero;
            let valor_abonos = totales_factura?.total_abonos;
            if (valot_total_fac >= (sumPayments + sumRetentionsToInvoice)) {
                incomeToPay = valot_total_fac - sumPayments - sumRetentionsToInvoice;
                setIncomeToPay(incomeToPay);
            } else {
                setIncomeToPay('0');
            }
        }
        //Cuando se visualiza los pagos de la factura
        if (paymentById !== null && paymentById !== undefined) {
            let invoice = invoices.filter((invoice) => invoice.id_factura_t === paymentById[0].id_factura_t);
            setInvoiceInfo(invoice);
            let valueTotal = invoice[0].total;

            let totales_factura = calculateTotal(invoice[0]);
            console.log('TOTALESFAC', totales_factura);
            let valot_total_fac = totales_factura?.total_tercero;
            let valor_abonos = totales_factura?.total_abonos;

            let sumPayments = addPayments(paymentById);
            if (valot_total_fac >= sumPayments) {
                let incomeToPay = valot_total_fac - sumPayments;
                setIncomeToPay(incomeToPay);
            } else {
                setIncomeToPay('0')
            }

        }
    }


    const listInvoice = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.length > 0) {
                    console.log("FACTURAS", data);
                    setInvoices(data);
                    //filterData(data);
                }
                else {
                    setInvoices([]);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const filterData = (data) => {
        let orderData = [];
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            data[i].fecha_emision_format = moment(data[i].fecha_emision).format("YYYY-MM-DD");
            data[i].vencimiento_format = moment(data[i].fecha_emision).format("YYYY-MM-DD");
            //orderData.push(element.num)

        }
        setInvoices(data);
    }

    const getPayments = async () => {
        setLoadTable(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("DATOSGET", data);
                let filterPaymentsFromRetention = filterPayments(data);
                let filterRetentionsFromPayments = filterRetentions(data);
                setPayments(filterPaymentsFromRetention);
                if (selectedInvoice !== null && selectedInvoice !== undefined) {
                    goToInvoice(selectedInvoice.num_fac_ter);
                }
                setLoadTable(false);
            })
            .catch((error) => {
                console.log(error)
            })
    };


    //discrimina los pagos de las retenciones
    const filterPayments = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== true);
            return resul;
        }

    }

    //discrimina las retenciones de los pagos
    const filterRetentions = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            return resul;
        }

    }

    //calcula el monto de todas las retenciones creadas a la factura 
    const calculateRetentionsValueToInvoice = (retentions) => {
        let valueFromRetentions = 0;
        if (retentions !== null && retentions !== undefined) {
            retentions.forEach((ret) => valueFromRetentions += ret.importe)
        }
        setTotalValueFromRetentionsToInvoice(valueFromRetentions);
        return valueFromRetentions;
    }

    //pagos/consultar?id_factura_t=
    const getPaymentById = async (id_factura) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                if (isMounted) {
                    console.log("PAYMENTSBYINVOICE", data);
                    setSelectedInvoice(null);
                    let filterPaymentsFromRetention = filterPayments(data);
                    setPaymentById(filterPaymentsFromRetention);
                } else {
                    setPaymentById(null);
                }
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const getAllPaymentsById = (id_factura) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error(response.json());
                    }
                })
                .then((data) => {
                    if (isMounted) {
                        resolve(data);
                    }
                })
                .catch((error) => {
                    console.log(error)
                    reject(error);
                })
        })
    };

    // suma todos los importes de los pagos de una factura
    const addPayments = (data) => {
        /*  data.reduce((acc, current) => {
             console.log("reduce", acc, current)
             let result = acc + current.importe;
             return result
         }, 0); */
        let acc = 0;
        data.forEach((element) => {
            acc += element.importe;
        })
        return acc;
    }


    const goToInvoice = async (num_fac_ter) => {
        try {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-numero', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ num_fac_ter: num_fac_ter })
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.factura != null) {
                    let factura = data.factura;
                    setSelectedInvoice(factura);
                    setInvoiceInfo(factura);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
        catch (e) {
            console.log(e);
        }
    }

    const reactTableDataPayments = {
        tableHeaderData: [{
            Header: 'PAGO No.',
            accessor: 'id_pago',
            //disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'FACTURA',
            accessor: 'num_fac_ter',
        },
        {
            Header: 'IMPORTE',
            accessor: 'importe',
            Cell: row => (
                <label>${formatNumber(Math.ceil(row.value))}</label>
            )
        },
        {
            Header: 'MODO DE PAGO',
            accessor: 'forma_pago'
        },
        {
            Header: 'FECHA DE PAGO',
            accessor: 'fecha_pago',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        {
            Header: 'ID DE LA TRANSACCIÓN',
            accessor: 'transaccion',
        },
        {
            Header: 'NOTA',
            accessor: 'nota',
        },
        ],
        tableRowsData: payments
    };

    const invoiceToEdit = (payment, onEdit) => {
        let invoiceToUpdate = invoices.find((invoice) => invoice.id_factura_t === payment.id_factura_t);
        console.log("FACACTUALIZArAct", invoiceToUpdate);
        setOnEdit(onEdit);
        goToInvoice(invoiceToUpdate.num_fac_ter);
        //setSelectedInvoice(invoiceToUpdate);
        setPaymentToEdit(payment);
        setPaymentById(null);
    }

    const incomeToPayWhatsLeft = (invoiceToPay) => {
        console.log("FACACTUALIZAr", invoiceToPay);
        goToInvoice(invoiceToPay.num_fac_ter)
        //setSelectedInvoice(invoiceToPay[0]);
        setPaymentById(null);
        setOnEdit(false);
    }

    const LoadInfo = () => {
        return (<DataReactTablePayments
            reactTableData={reactTableDataPayments}
            refresh={getPayments}
            getPaymentById={getPaymentById}
            invoiceToEdit={invoiceToEdit}
        />)
    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }
    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    const onSelectedInvoice = (e) => {
        setPaymentById(null); //Borra la previsualizacion de los pagos
        setOnEdit(false);
        setIncomeToPay(''); //reset al campo de importe a pagar 
        goToInvoice(e.target.value.num_fac_ter);
    }

    return (
        <Fragment>
            <Card>
                <CardBody style={{ height: '100%' }}>
                    {
                        !load ?
                            <Row>
                                <Col md={12}>
                                    <TextField
                                        required
                                        select
                                        id="invoice-selected-required"
                                        label="Seleccione una Factura"
                                        type="text"
                                        className="medical-material-form__field"
                                        value={selectedInvoice}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        onChange={(e) => {
                                            onSelectedInvoice(e);
                                            console.log('EVENTO', e)
                                        }}
                                    >
                                        {invoices.map((invoice) => (
                                            <MenuItem key={invoice.num_fac_ter} value={invoice}>
                                                {invoice.num_fac_ter} <span style={{ color: colorStateInvoice(invoice.estado_pago) }}>  -  {stateInvoice(invoice.estado_pago)}</span>
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Col>
                            </Row>
                            :
                            <div className="text-center">
                                <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                            </div>
                    }
                    {
                        selectedInvoice !== null && selectedInvoice !== undefined && paymentById === null ?
                            <Fragment>
                                <Row>
                                    <Col md={12}>
                                        <h4 style={{ margin: '1em 0em' }}><b>{onEdit ? 'ACTUALIZAR' : 'REGISTRAR'} PAGO A LA FACTURA {selectedInvoice.num_fac_ter}</b></h4>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '1em 0em' }}>
                                            <div><p><b>Cliente: </b>{selectedInvoice.nombre_facturado}</p></div>
                                            <div><p><b>Total de la Factura: $</b>{formatNumber(totalInvoice)}</p></div>
                                            <div><p><b>Fecha de Emisión: </b>{moment(selectedInvoice.fecha_emision_format).format('DD-MM-YYYY')}</p></div>
                                            <div><p><b>Importe a Pagar: $ {formatNumber(incomeToPay)}</b></p></div>
                                            <div><p><b>Estado: </b><span style={{ color: colorStateInvoice(selectedInvoice.estado_pago) }}><FontAwesomeIcon icon={faCircle} style={{ color: colorStateInvoice(selectedInvoice.estado_pago) }} /> {stateInvoice(selectedInvoice.estado_pago)}</span></p></div>
                                        </div>
                                        <Row>
                                            {retentionsToInvoice &&
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
                                                    {retentionsToInvoice.length > 0 ?
                                                        <Fragment>
                                                            <div><h5><b>RETENCIONES: </b></h5></div>
                                                            <div>
                                                                {
                                                                    retentionsToInvoice.map((ret) => (
                                                                        <ChipShowRetentionToInvoice retention={ret} />
                                                                    ))
                                                                }
                                                            </div>
                                                            <div><h5><b>= ${formatNumber(totalValueFromRetentionsToInvoice)}</b></h5></div>
                                                        </Fragment>
                                                        : null}
                                                </div>
                                            }
                                        </Row>
                                        <hr style={{ color: '#55e5bb' }}></hr>
                                        <FormAddPayment refresh={getPayments} selectedInvoice={selectedInvoice} paymentToEdit={paymentToEdit} onEdit={onEdit} setOnEdit={setOnEdit} incomeToPay={incomeToPay} />
                                    </Col>
                                </Row>
                            </Fragment>
                            : paymentById !== null ?
                                <Row>
                                    <div className='cards-payments-display' >
                                        {paymentById.map((paymentToInvoice) => (
                                            <ShowPayment key={paymentToInvoice.id_pago} payment={paymentToInvoice} invoiceInfo={invoiceInfo} incomeToPay={incomeToPay} invoiceToEdit={invoiceToEdit} setShowPaymentPDF={setShowPaymentPDF} incomeToPayWhatsLeft={incomeToPayWhatsLeft} totalInvoice={totalInvoice} />
                                        ))
                                        }
                                    </div>
                                </Row>
                                : null
                    }
                    <Row>
                        <Col>
                            {
                                loadTable ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : payments.length !== 0 && invoices !== null && invoices.length !== 0 ?
                                        <LoadInfo />
                                        : null
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            {showPaymentPDF ?
                <Modal
                    open={showPaymentPDF}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPaymentPDF(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                        </iframe>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default PaymentSection